import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '@/lib/axios';

const ART = {
  sepa_ueberweisung: 'Überweisung, zur Freigabe vorgemerkt',
  lohnabrechnung: 'Lohnabrechnung',
  csv: 'CSV',
  pdf: 'PDF',
  lastschrift: 'Lastschrift, nicht übernommen',
  unbekannt: 'Nicht erkannt',
};

export default function SteuerberaterDrop() {
  const { token } = useParams();
  const [offen, setOffen] = useState(null);
  const [dateien, setDateien] = useState([]);
  const [ergebnis, setErgebnis] = useState([]);
  const [busy, setBusy] = useState(false);
  const [fehler, setFehler] = useState('');

  useEffect(() => {
    api.get(`/public/steuerberater/${token}`)
      .then(() => setOffen(true))
      .catch((e) => {
        setOffen(false);
        setFehler(e.response?.data?.detail || 'Dieser Link ist nicht mehr gültig.');
      });
  }, [token]);

  const senden = async () => {
    if (!dateien.length) return;
    setBusy(true);
    setFehler('');
    try {
      const daten = new FormData();
      dateien.forEach((datei) => daten.append('files', datei));
      const antwort = await api.post(`/public/steuerberater/${token}`, daten);
      setErgebnis(antwort.data?.files || []);
      setDateien([]);
    } catch (e) {
      setFehler(e.response?.data?.detail || 'Der Upload ist fehlgeschlagen.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen bg-slate-50 text-slate-900 px-4 py-10" data-testid="steuerberater-drop">
      <div className="max-w-lg mx-auto bg-white border border-slate-200 rounded-xl p-6 space-y-4">
        <h1 className="text-xl font-bold">Unterlagen hochladen</h1>
        <p className="text-sm text-slate-600">
          Lohnabrechnungen und Überweisungs-XML werden automatisch erkannt.
          Eine Überweisung geht hier nicht an die Bank.
        </p>
        {offen === false && <p className="text-sm text-rose-700" data-testid="steuerberater-drop-error">{fehler}</p>}
        {offen && (
          <>
            <input
              type="file"
              multiple
              accept=".pdf,.csv,.xml,application/pdf,text/csv,text/xml,application/xml"
              data-testid="steuerberater-drop-file"
              onChange={(e) => setDateien(Array.from(e.target.files || []))}
            />
            <button
              type="button"
              className="rounded-md bg-slate-900 text-white px-4 py-2 text-sm disabled:opacity-50"
              onClick={senden}
              disabled={busy || !dateien.length}
              data-testid="steuerberater-drop-send"
            >
              {busy ? 'Wird erkannt…' : 'Hochladen'}
            </button>
            {fehler && <p className="text-sm text-rose-700">{fehler}</p>}
          </>
        )}
        {ergebnis.length > 0 && (
          <ul className="text-sm space-y-2" data-testid="steuerberater-drop-result">
            {ergebnis.map((zeile) => (
              <li key={zeile.filename}>
                <span className="font-medium">{zeile.filename}</span>
                {' · '}
                {zeile.hinweis || ART[zeile.art] || zeile.art}
              </li>
            ))}
          </ul>
        )}
      </div>
    </main>
  );
}
